import { Alert } from "antd";
import styleLess from "./index.module.less";

export default function AntAlert(options) {
  const { theme } = options;
  return (
    <div className={`${styleLess.main} ${theme}`}>
      {" "}
      <Alert {...options} />{" "}
    </div>
  );
}
